<div class="pad-top-20 margin-bottom-20 row column twelve lg-push-two md-eight md-push-two">
  <h1 class="main-header">Review your new vehicle quote</h1>

  @if (quote$ | async; as quote) {
    <amfam-quote-cards [quote]="quote"></amfam-quote-cards>
  }

  <div class="gray-outline-box">
    <amfam-wrap-article
      headerContentRef="policy.premiumBilling.vehicleAddedHeader"
      [content]="vehicleRiskDescription$ | async"
      contentIconPath="/assets/images/vehicle-add-icon.png"
    >
    </amfam-wrap-article>
    @if (vehiclesLeft$ | async; as vehiclesLeft) {
      <amfam-wrap-article
        [headerContentRef]="
          vehiclesLeft.length > 1
            ? 'policy.premiumBilling.vehiclesLeftHeader'
            : 'policy.premiumBilling.vehicleLeftHeader'
        "
        [content]="vehiclesLeftCommaSeparated$ | async"
      >
      </amfam-wrap-article>
    }
  </div>

  <amfam-wrap-section
    [headerContentRef]="{
      path: 'policy.premiumBilling.vehicleCoveragesHeader',
      options: { newVehicle: (vehicleRiskDescription$ | async) }
    }"
    iconClass="icon-auto"
    [itemList]="vehicleCoveragesSummaryList$ | async"
  ></amfam-wrap-section>

  <amfam-wrap-section
    [headerContentRef]="{ path: 'policy.premiumBilling.policyCoveragesHeader' }"
    iconClass="icon-claims"
    [itemList]="policyCoveragesSummaryList$ | async"
  ></amfam-wrap-section>

  <amfam-wrap-section
    [headerContentRef]="{ path: 'policy.premiumBilling.discountsHeader' }"
    iconClass="icon-complete-circle"
    [itemList]="
      (isPartner$ | async)
        ? (discountsOnCoveragesSummaryListPartners$ | async)
        : (discountsOnCoveragesSummaryList$ | async)
    "
  ></amfam-wrap-section>

  <amfam-wrap-section
    [headerContentRef]="{ path: 'policy.premiumBilling.futurePaymentHeader' }"
    iconClass="icon-calendar"
    [itemList]="futurePayments$ | async"
  ></amfam-wrap-section>

  <div
    dsContent
    [contentPath]="'policy.premiumBilling.addVehicle.disclaimer'"
    class="font-size-0-75"
  ></div>
</div>

<div class="column twelve lg-push-two md-eight md-push-two">
  <call-to-action
    [displayBackButton]="true"
    [tertiaryButtonName]="'Cancel'"
    [primaryButtonName]="'Add Vehicle'"
    (primaryEvent)="onlineBind()"
    [secondaryButtonName]="(isPartner$ | async) ? 'Send to an advisor' : 'send to my agent'"
    (secondaryEvent)="notifyAgentEvent.emit({ isProcessExited: true })"
    [disableSecondaryButton]="(authorized$ | async) !== true"
    (tertiaryEvent)="cancelEvent.emit(true)"
    (backEvent)="goBackOneStep()"
  ></call-to-action>
</div>
